import { DemeterMarket } from '../../Generated/Raven-Demeter/api';

export const marketsWithRegionCommodityGrouping: DemeterMarket[] = [DemeterMarket.Dairy, DemeterMarket.Sugar, DemeterMarket.Coffee];

export const isRegionCommodityGroupedMarket = (market?: DemeterMarket): boolean => !!market && marketsWithRegionCommodityGrouping.includes(market);
